export function getInquiryVisibility(inqType: number, portalMode: boolean) {
  console.assert(!!inqType, 'getInquiryVisibility type empty');
  const v: any = {};

  v.selfRetention = false;
  v.insurableTurnover = false;
  v.countries = true;
  v.buyers = false;
  v.receivables = false;
  v.currentInsurer = false;
  v.lastBalances = false;

  v.countriesSumDomestic = false;
  v.countriesSumExport = false;
  v.countriesSumLastYear = false;
  v.domesticInsurable = false;
  v.exportInsurable = false;
  v.policyValidFrom = false;
  v.falconLimitAllowed = false;
  v.divisionIntoFactorers = false;

  v.subinsureds = true;

  v.statements = {};

  v.ratedLimits = false;

  v.debtorBuyerUltimateUserSection = false;
  v.transactionPartiesSection = false;
  v.exportersSection = false;
  v.guarantorsSection = false;

  v.limitFeesSection = false;

  return v;
}
